import { ValueTypeSwitcher } from 'legacy/lut/components/widgets/public/partner360/common/valueTypeSwitcher/ValueTypeSwitcher'
import { FC } from 'react'

import { useActualsTypes } from './hooks/useActualsTypes'
import { IActualsTypeButtonProps } from './models/actualsTypeButtonProps'

export const ActualsTypeButtons: FC<IActualsTypeButtonProps> = () => {
  /** -------------------- Variables ----------------------- */
  const { actualsType, actualsTypes, onChangeActualsType } = useActualsTypes()
  return (
    <ValueTypeSwitcher
      onChangeValueType={onChangeActualsType}
      valueTypes={actualsTypes}
      valueType={actualsType}
    />
  )
}
